// @ts-nocheck
import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import Courses from '../components/courses/list'
import CreateCourse from '../components/courses/create'
import ShowCourse from '../components/courses/show'
import EditCourse from '../components/courses/edit'

import Curriculums from '../components/curriculums/list'
import CreateCurriculum from '../components/curriculums/create'
import EditCurriculum from '../components/curriculums/edit'
import ShowCurriculum from '../components/curriculums/show'
import ShowCurriculumTypes from '../components/curriculums/show-types'

import Webinars from '../components/webinars/list'
import CreateWebinar from '../components/webinars/create'
import EditWebinar from '../components/webinars/edit'

import CoreCurriculumWebinars from '../components/core-curriculum-webinars/list'
import CreateCoreCurriculumWebinar from '../components/core-curriculum-webinars/create'
import EditCoreCurriculumWebinar from '../components/core-curriculum-webinars/edit'

import SessionSales from '../components/session-sales/list'
import CreateSessionSale from '../components/session-sales/create'
import ShowSessionSale from '../components/session-sales/show'
import EditSessionSale from '../components/session-sales/edit'

import SessionReservations from '../components/session-sales/reservations/list'
import CreateSessionReservation from '../components/session-sales/reservations/create'
import EditSessionReservation from '../components/session-sales/reservations/edit'

import SessionWaitlisters from '../components/session-sales/waitlist/list'
import ShowSessionWaitlister from '../components/session-sales/waitlist/show'

import SessionSaleSummary from '../components/session-sales/summary'
import SessionSaleIntakeQuestions from '../components/session-sales/intake-questions'
import SessionSaleRegistrationBlocks from '../components/session-sales/registration-blocks'

import Categories from '../components/categories/webinar-list'
import CreateCategory from '../components/categories/create'
import EditCategory from '../components/categories/edit'
import ReservationImport from '../components/session-sales/reservation-import'
import WebinarRegistrationsImport from '../components/WebinarRegistrationsImportPage'
import WebinarTagsImport from '../components/WebinarTagsImportPage'

const EventRoutes = (
  <Route path='events'>
    <Route path='courses'>
      <IndexRoute component={Courses} />
      <Route path='create' component={CreateCourse} />
      <Route path=':courseId' component={ShowCourse}>
        <IndexRoute to='edit' />
        <Route path='edit' component={EditCourse} />
        <Route path='webinars'>
          <IndexRoute component={Webinars} />
          <Route path='create' component={CreateWebinar} />
          <Route path=':webinarId/edit' component={EditWebinar} />
        </Route>
      </Route>
    </Route>

    <Route component={ShowCurriculumTypes}>
      <IndexRoute to='curriculums' />
      <Route path='curriculums'>
        <IndexRoute component={Curriculums} />
        <Route path='create' component={CreateCurriculum} />
      </Route>
      <Route path='core-curriculum'>
        <IndexRoute component={CoreCurriculumWebinars} />
        <Route path='create' component={CreateCoreCurriculumWebinar} />
        <Route path=':coreCurriculumWebinarId/edit' component={EditCoreCurriculumWebinar} />
      </Route>
    </Route>

    <Route path='curriculums/:curriculumId' component={ShowCurriculum}>
      <IndexRoute to='edit' />
      <Route path='edit' component={EditCurriculum} />
      <Route path='webinars'>
        <IndexRoute component={Webinars} />
        <Route path='create' component={CreateWebinar} />
        <Route path=':webinarId/edit' component={EditWebinar} />
      </Route>
    </Route>

    <Route path='webinars'>
      <IndexRoute component={Webinars} />
      <Route path='create' component={CreateWebinar} />
      <Route path=':webinarId/edit' component={EditWebinar} />
      <Route path='categories' component={Categories} />
      <Route path='categories/create' component={CreateCategory} />
      <Route path='categories/:id/edit' component={EditCategory} />
      <Route path='import-registrations' component={WebinarRegistrationsImport} />
      <Route path='import-tags' component={WebinarTagsImport} />
    </Route>

    <Route path='categories'>
      <IndexRoute component={Categories} />
      <Route path='create' component={CreateCategory} />
      <Route path=':id/edit' component={EditCategory} />
    </Route>

    <Route path='session-sales'>
      <IndexRoute component={SessionSales} />
      <Route path='create' component={CreateSessionSale} />
      <Route path=':sessionSaleId' component={ShowSessionSale}>
        <IndexRedirect to='summary' />

        <Route path='summary' component={SessionSaleSummary} />
        <Route path='edit' component={EditSessionSale} />

        <Route path='reservations' component={SessionReservations} />
        <Route path='reservations/import' component={ReservationImport} />
        <Route path='reservations/create' component={CreateSessionReservation} />
        <Route path='reservations/:sessionReservationId/edit' component={EditSessionReservation} />

        <Route path='waitlist' component={SessionWaitlisters} />
        <Route path='waitlist/:waitlisterId/show' component={ShowSessionWaitlister} />

        <Route path='intake-questions' component={SessionSaleIntakeQuestions} />
        <Route path='registration-blocks' component={SessionSaleRegistrationBlocks} />
      </Route>
    </Route>
  </Route>
)

export default EventRoutes
